// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"7":"5f5d1722","170":"133a7592","261":"dcf7f62e"}[chunkId] + ".chunk.js";
};